module.exports = __webpack_public_path__ + "static/media/preview.ca0f843c.svg";